module.exports = __webpack_public_path__ + "c141ce23f18cf6fcc146497fbce702cf.svg";